<template>
  <div>
    <section>
      <template>
        <v-container>
          <v-row class="match-height">
            <v-col
              cols="12"
              :sm="$containerBreakpoint.smAndUp ? '12' : '12'"
              :md="$containerBreakpoint.mdAndUp ? '6' : '12'"
            >
              <v-skeleton-loader
                v-if="dataIsLoading"
                elevation="2"
                type="card, list-item-avatar-three-line, list-item-avatar-three-line"
              ></v-skeleton-loader>
              <personnel-record-contact-card
                v-else
                type="personal"
                :contact="data.personal"
              ></personnel-record-contact-card>
            </v-col>

            <v-col
              cols="12"
              :sm="$containerBreakpoint.smAndUp ? '12' : '12'"
              :md="$containerBreakpoint.mdAndUp ? '6' : '12'"
            >
              <v-skeleton-loader
                v-if="dataIsLoading"
                elevation="2"
                type="card, list-item-avatar-three-line, list-item-avatar-three-line"
              ></v-skeleton-loader>
              <personnel-record-contact-card
                v-else
                type="business"
                :contact="data.business"
              ></personnel-record-contact-card>
            </v-col>
            <v-col
              cols="12"
              :sm="$containerBreakpoint.smAndUp ? '12' : '12'"
              :md="$containerBreakpoint.mdAndUp ? '6' : '12'"
            >
              <v-skeleton-loader
                v-if="dataIsLoading"
                elevation="2"
                type="card, list-item-avatar-three-line, list-item-avatar-three-line"
              ></v-skeleton-loader>
              <personnel-record-contact-card
                v-else
                type="station"
                hideAdress
                :contact="data.station"
              ></personnel-record-contact-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
  </div>
</template>

<script>
import { db } from "@/firebase";
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import PersonnelRecordContactCard from "@/components/member-management/personnel-records/PersonnelRecordContactCard.vue";
import containerBreakpoints from "@/mixins/containerBreakpoints.js";

export default {
  name: "member-management-personnel-records-details-contact",
  mixins: [containerBreakpoints],
  components: {
    PersonnelRecordContactCard,
    SupportTools,
  },
  props: {
    personnelRecord: Object,
    propContainerWidth: {
      type: Number,
      default: 0,
    },
    propPersonnelRecordId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dataIsLoading: true,
      data: null,
    };
  },
  computed: {
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    code() {
      return [{ title: "data", data: this.data }];
    },
    // Use prop ID if available (split screen mode), otherwise fall back to route param
    personnelRecordId() {
      return this.propPersonnelRecordId || this.$route.params.itemId;
    },
  },
  created() {
    this.initialize();
  },
  mounted() {
    // Only initialize container breakpoints if not in split pane context
    // (propContainerWidth watcher handles split pane case)
    if (!(this.propContainerWidth > 0)) {
      this.initContainerBreakpoints(this.$el);
    }
  },
  watch: {
    $route: "initialize",
    // Watch prop changes from parent component
    propContainerWidth: {
      immediate: true,
      handler(newWidth) {
        if (newWidth > 0) {
          // Only update if the breakpoint would change (to prevent unnecessary re-renders)
          const newBreakpoint = this._getBreakpointForWidth(newWidth);
          const currentBreakpoint = this._getBreakpointForWidth(
            this.containerWidth || 0
          );
          if (
            newBreakpoint !== currentBreakpoint ||
            this.containerWidth === 0
          ) {
            this.containerWidth = newWidth;
          }
        }
      },
    },
  },
  methods: {
    initialize() {
      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("personnelRecords_contact")
        .doc(this.personnelRecordId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.data = doc.data();
            this.dataIsLoading = false;
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });
    },
  },
};
</script>

<style></style>
